
import { useState, useEffect, useCallback } from 'react';
import API from '../api/api';
import { semesterService } from '../Services/semesterService';
import { handleApiError } from '../Utils/ApiErrorHandler';
import { useDispatch } from 'react-redux';
import { setSuccessSnack } from '../Reducers/snackSuccess';

const useGetSemesters = () => {

    const dispatch = useDispatch();
    const [semesters, setList] = useState([]);
    const [error, setError] = useState(null);

    // Separate loading states
    const [loading, setLoading] = useState(false);
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [deleting, setDeleting] = useState(false);


    // all data
    const fetchData = async() => {
        try {
            setLoading(true);
            const request = await semesterService.getSemesters();
            setList(request);
            return request;
        }
        catch(error) {
            handleApiError(error, dispatch, "get semesters")
            return null;
        }
        finally {
            setLoading(false);
        }
    }


    const createSemester = async (values) => {
        try {
          setCreating(true);
          const data = await semesterService.createSemester(values);
          
          if (data.status === 'OK') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: `Created semester successfully with id ${data.id}`
            }));
            await fetchData(); // Refresh list
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'create semester');
          return false;
        } finally {
          setCreating(false);
        }
      };
      
      const updateSemester = async (values) => {
        try {
          setUpdating(true);
          const data = await semesterService.updateSemester(values);
          
          if (data.status === 'Updated') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: 'Updated semester'
            }));
            await fetchData(); // Refresh list
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'update semester');
          return false;
        } finally {
          setUpdating(false);
        }
      };

      const deleteSemester = async (id) => {
        if (!id) return false;
        try {
          setDeleting(true);
          const data = await semesterService.deleteSemester(id);
          if (data.status === 'Removed') {
            dispatch(setSuccessSnack({
              title: 'Success', 
              body: 'Removed semester'
            }));
            return true;
          }
          return false;
        } catch (error) {
          handleApiError(error, dispatch, 'delete semester');
          return false;
        } finally {
          setDeleting(false);
        }
      };

      const filterSemesters = () => { 
        const s = semesters.filter((item) => !item.archive);
        setList(s);
      } 

    useEffect(() => {
        fetchData();
    }, [])


    return { semesters, loading, error, updating, creating, deleting , refetch: fetchData, deleteSemester, updateSemester, createSemester, filterSemesters};
}

export default useGetSemesters;